import React from "react";

const NotFound = () => {
  return <div className="text-danger">
      Your looking page not found!!
  </div>
}

export default NotFound